import { IParamsGetAllIndustry } from 'app/api/industry/model/management'

export const IndustryKeys = {
  allIndustries: ['Industries'] as const,
  listIndustries: () => [...IndustryKeys.allIndustries, 'Industries'] as const,
  listIndustry: (filters?: IParamsGetAllIndustry) =>
    [...IndustryKeys.listIndustries(), { filters }] as const,
}
